export class WelcomeComponentKey {
  static readonly SETUP_USER = 'welcome/component/setup-user';
}
